<template>
  <v-dialog v-model="exibir" max-width="420" persistent transition="dialog-bottom-transition">
    <v-card rounded="xl" class="pa-4 text-center d-flex">
      <div class="mt-4 mb-6 d-flex justify-center">
        <v-img :src="LogoTekTekSystem" max-width="220" height="auto" />
      </div>

      <v-avatar color="primary-lighten-4" size="64" class="mb- text-primary d-flex w-100 align-center">
        <v-icon size="36">mdi-cloud-arrow-down</v-icon>
      </v-avatar>

      <v-card-text class="pa-0">
        <h2 class="text-h6 font-weight-bold text-grey-darken-4 mb-2">Nova versão disponível!</h2>

        <p class="text-body-2 text-medium-emphasis px-2 mb-6">
          Atualizamos nossa plataforma para oferecer uma experiência ainda melhor e mais rápida. O processo leva apenas
          alguns segundos.
        </p>

        <div class="px-4 mb-2">
          <v-progress-linear
            v-if="!loading"
            :model-value="(countdown / 12) * 100"
            color="primary"
            height="6"
            rounded
          ></v-progress-linear>
        </div>

        <div v-if="!loading" class="text-caption text-medium-emphasis mb-6">
          Atualizando automaticamente em <strong>{{ countdown }}s</strong>...
        </div>
        <div v-else class="text-caption text-primary font-weight-bold mb-6">Aplicando atualização, aguarde...</div>

        <v-btn
          color="primary"
          variant="flat"
          size="large"
          block
          rounded="lg"
          elevation="2"
          :loading="loading"
          prepend-icon="mdi-refresh"
          @click="onClickAtualizar()"
        >
          Atualizar Agora
        </v-btn>
      </v-card-text>
    </v-card>
  </v-dialog>
</template>

<script setup lang="ts">
// Vue
import { ref, watch, onUnmounted } from 'vue';
import { useRegisterSW } from 'virtual:pwa-register/vue';

// Stores
import { useLayoutStore } from '@/stores/LayoutStore';

// Assets
import LogoTekTekSystem from '@/assets/LogoTekTekSystem.png';

const layoutStore = useLayoutStore();
let timer: ReturnType<typeof setInterval> | null = null;

const { offlineReady, needRefresh, updateServiceWorker } = useRegisterSW({
  onNeedRefresh() {
    exibir.value = true;
    iniciarContador();
  },
});

// Variáveis reativas
const countdown = ref<number>(12);
const exibir = ref<boolean>(false);
const loading = ref<boolean>(false);

async function onClickAtualizar() {
  // Impede múltiplos cliques
  if (loading.value) return;

  loading.value = true;

  try {
    await updateServiceWorker();
  } catch (error) {
    loading.value = false;
    layoutStore.setMessageDialog({ tipo: 'error', mensagem: String(error) });
    throw error;
  }
}

watch(countdown, (newValue) => {
  if (newValue === 0 && !loading.value) {
    onClickAtualizar();
  }
});

function iniciarContador() {
  countdown.value = 12;
  timer = setInterval(() => {
    if (countdown.value > 0) {
      countdown.value--;
    } else {
      if (timer) clearInterval(timer);
      timer = null;
    }
  }, 1000);
}

onUnmounted(() => {
  if (timer) {
    clearInterval(timer);
    timer = null;
  }
});
</script>
